import { render, staticRenderFns } from "./TinyInfoTotalOpen.vue?vue&type=template&id=b8674776"
import script from "./TinyInfoTotalOpen.vue?vue&type=script&lang=ts"
export * from "./TinyInfoTotalOpen.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b8674776')) {
      api.createRecord('b8674776', component.options)
    } else {
      api.reload('b8674776', component.options)
    }
    module.hot.accept("./TinyInfoTotalOpen.vue?vue&type=template&id=b8674776", function () {
      api.rerender('b8674776', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/dashboard/TinyInfoTotalOpen.vue"
export default component.exports